module.exports = Em.Handlebars.compile("<div class=\"name\">{{name}}</div>");